'use client';

import { useCallback, useTransition } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { setUserLocale } from '@/hotdesk-ui/lib/language.service';
import { withLangParam } from '@/hotdesk-ui/helpers/language-url';

/**
 * Sets the locale cookie and updates `?lang=` so middleware does not
 * overwrite the choice on the next request.
 * Updates the dropdown label immediately (optimistic) to avoid mismatch delay.
 */
export function useChangeLanguage(
    onDisplayLanguage?: (displayLanguage: string) => void
) {
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const [, startTransition] = useTransition();

    return useCallback(
        (value: string) => {
            // Update the select immediately — don't wait on the server action.
            onDisplayLanguage?.(`language.${value}`);

            startTransition(async () => {
                await setUserLocale(value);
                router.replace(withLangParam(pathname, searchParams, value));
            });
        },
        [onDisplayLanguage, pathname, router, searchParams, startTransition]
    );
}
